import {
  View,
  Text,
  Image,
  Keyboard,
  TextInput,
  FlatList,
  ScrollView,
  TouchableOpacity,
} from "react-native";
import React, { useEffect, useState } from "react";
import {
  CommonActions,
  DrawerActions,
  StackActions,
  useNavigation,
} from "@react-navigation/native";
import {
  useDeviceSize,
  CreateResponsiveStyle,
  DEVICE_SIZES,
} from "rn-responsive-styles";
import { AppColors } from "../../../utility/AppColors";
import { AppFontStyle } from "../../../styles/AppFontStyle";
import { AppImages } from "../../../utility/AppImages";
import {
  getLoginData,
  getSessionId,
  removeSessionId,
} from "../../../utility/AppStoreData";
import { regexForSuccess, screenWidth } from "../../../utility/Index";
import { AppScreens } from "../../Utility/AppScreens";
import VerificationModal from "./VerificationModal";
import PurchaseSuccess, { enumPurchaseSuccess } from "./PurchaseSuccess";
import { base_url, endpoints } from "../../../Api/configs";
import { toast } from "react-toastify";
import { ShowLoader } from "../../../common/ShowLoader";
import * as WebBrowser from "expo-web-browser";
import * as Linking from "expo-linking";
import PurchaseSessionSuccessModal from "./PurchaseSessionSuccessModal";
import { fetchPurchaseSuccess } from "../../../services/profileAPI";

const PaymentDone = ({ route }) => {
  const navigation = useNavigation();
  const styles = useStyles();
  const [userData, setUserData] = useState(null);
  const [showSuccessModal, setShowSuccessModal] = useState(true);
  const [showLoader, setShowLoader] = useState(false);
  const [userTokens, setUserTokens] = useState("");
  const [sessionId, setSessionId] = useState(route?.params?.session_id || "");
  const { eventID } = route.params || {};

  useEffect(() => {
    getLoginUserData();
  }, []);

  async function getLoginUserData() {
    const data = await getLoginData();
    if (data) {
      setUserData(data);
      if (sessionId) {
        callPurchaseSuccessApi(sessionId, data.AccessToken);
      }
    }
  }

  async function callPurchaseSuccessApi(session_id, accessToken) {
    setShowLoader(true);
    removeSessionId();
    try {
      const data = await fetchPurchaseSuccess(session_id, accessToken);
      setShowLoader(false);
      if (data) {
        setUserTokens(data.tokens.toString());
      } else {
        toast.error(
          data.error || "An error occurred during purchase success processing"
        );
      }
    } catch (error) {
      setShowLoader(false);
      toast.error(error.message);
    }
  }
  return (
    <View style={[styles.container, {}]}>
      <View
        style={{
          height: "7%",
          width: "100%",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <Text
          style={[
            AppFontStyle.BOLD_ANYBODY_32,
            {
              color: AppColors.white,
              alignItems: "center",
              justifyContent: "center",
              alignSelf: "center",
            },
          ]}
        >
          Purchase tokens
        </Text>
        <View
          style={{
            justifyContent: "center",
            flexDirection: "row",
            alignItems: "center",
            gap: 10,
          }}
        >
          <Text
            style={[
              AppFontStyle.BOLD_ANYBODY_14,
              {
                color: AppColors.white,
                alignItems: "center",
                justifyContent: "center",
                alignSelf: "center",
              },
            ]}
          >
            {userData != null ? userData.username : ""}
          </Text>

          <View
            style={{
              height: "80%",
              aspectRatio: 1,
              backgroundColor: AppColors.appViolentColor_6D08C3,
              borderRadius: 100,
            }}
          ></View>
        </View>
      </View>
      {showLoader && <ShowLoader showIndicater={showLoader} />}
      {showSuccessModal && (
        <PurchaseSessionSuccessModal
          showModal={showSuccessModal}
          setShowModal={setShowSuccessModal}
          tokenData={userTokens}
          eventID={eventID}
        />
      )}
    </View>
  );
};

export default PaymentDone;

const useStyles = CreateResponsiveStyle(
  {
    container: {
      flex: 1,
      backgroundColor: AppColors.black_121212,
      paddingHorizontal: "3.5%",
      paddingTop: "2.5%",
    },
    needHelpButtonStyle: {
      justifyContent: "flex-end",
      alignItems: "center",
      flexDirection: "row",
      paddingHorizontal: 20,
      marginVertical: 5,
      gap: 8,
    },
    packegeSelectionView: {
      borderRadius: 10,
      borderWidth: 1,
      borderColor: AppColors.appViolentColor_6D08C3,
      flexDirection: "row",
      overflow: "hidden",
    },
    separaterStyle: {
      height: 2,
      backgroundColor: AppColors.appGrayColor_1C1C1C,
      marginVertical: 10,
    },
    tokenButtonStyle: {
      justifyContent: "center",
      alignItems: "center",
      padding: 10,
      paddingHorizontal: 29,
    },
    packageBgView: {
      backgroundColor: AppColors.appBlackColor_1e1e1e,
      justifyContent: "space-between",
      borderRadius: 10,
      marginVertical: 5,
      marginHorizontal: 5,
      paddingHorizontal: 15,
      paddingVertical: 12,
      // width: screenWidth / 4,
      gap: 18,
    },
    purchaseNowButtonStyle: {
      height: 40,
      backgroundColor: AppColors.appViolentColor_6D08C3,
      borderRadius: 10,
      justifyContent: "center",
      paddingHorizontal: 30,
    },
  },
  {
    [DEVICE_SIZES.MD]: {
      container: {
        flex: 1,
        backgroundColor: AppColors.black_121212,
        paddingHorizontal: "3.5%",
        paddingTop: "2.5%",
      },
      needHelpButtonStyle: {
        justifyContent: "flex-end",
        alignItems: "center",
        flexDirection: "row",
        paddingHorizontal: 20,
        marginVertical: 5,
        gap: 8,
      },
      packegeSelectionView: {
        borderRadius: 10,
        borderWidth: 1,
        borderColor: AppColors.appViolentColor_6D08C3,
        flexDirection: "row",
        overflow: "hidden",
      },
      separaterStyle: {
        height: 2,
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        marginVertical: 10,
      },
      tokenButtonStyle: {
        justifyContent: "center",
        alignItems: "center",
        padding: 10,
        paddingHorizontal: 29,
      },
      packageBgView: {
        backgroundColor: AppColors.appBlackColor_1e1e1e,
        justifyContent: "space-between",
        borderRadius: 10,
        marginVertical: 5,
        marginHorizontal: 5,
        paddingHorizontal: 15,
        paddingVertical: 12,
        // width: screenWidth / 4,
        gap: 18,
      },
      purchaseNowButtonStyle: {
        height: 40,
        backgroundColor: AppColors.appViolentColor_6D08C3,
        borderRadius: 10,
        justifyContent: "center",
        paddingHorizontal: 30,
      },
    },
    [DEVICE_SIZES.LG]: {
      container: {
        flex: 1,
        backgroundColor: AppColors.black_121212,
        paddingHorizontal: "3.5%",
        paddingTop: "2.5%",
      },
      needHelpButtonStyle: {
        justifyContent: "flex-end",
        alignItems: "center",
        flexDirection: "row",
        paddingHorizontal: 20,
        marginVertical: 5,
        gap: 8,
      },
      packegeSelectionView: {
        borderRadius: 10,
        borderWidth: 1,
        borderColor: AppColors.appViolentColor_6D08C3,
        flexDirection: "row",
        overflow: "hidden",
      },
      separaterStyle: {
        height: 2,
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        marginVertical: 10,
      },
      tokenButtonStyle: {
        justifyContent: "center",
        alignItems: "center",
        padding: 10,
        paddingHorizontal: 29,
      },
      packageBgView: {
        backgroundColor: AppColors.appBlackColor_1e1e1e,
        justifyContent: "space-between",
        borderRadius: 10,
        marginVertical: 5,
        marginHorizontal: 5,
        paddingHorizontal: 15,
        paddingVertical: 12,
        // width: screenWidth / 4,
        gap: 18,
      },
      purchaseNowButtonStyle: {
        height: 40,
        backgroundColor: AppColors.appViolentColor_6D08C3,
        borderRadius: 10,
        justifyContent: "center",
        paddingHorizontal: 30,
      },
    },
    [DEVICE_SIZES.SM]: {
      container: {
        flex: 1,
        backgroundColor: AppColors.black_121212,
        paddingHorizontal: "3.5%",
        paddingTop: "2.5%",
      },
      needHelpButtonStyle: {
        justifyContent: "flex-end",
        alignItems: "center",
        flexDirection: "row",
        paddingHorizontal: 20,
        marginVertical: 5,
        gap: 8,
      },
      packegeSelectionView: {
        borderRadius: 10,
        borderWidth: 1,
        borderColor: AppColors.appViolentColor_6D08C3,
        flexDirection: "row",
        overflow: "hidden",
      },
      separaterStyle: {
        height: 2,
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        marginVertical: 10,
      },
      tokenButtonStyle: {
        justifyContent: "center",
        alignItems: "center",
        padding: 10,
        paddingHorizontal: 29,
      },
      packageBgView: {
        backgroundColor: AppColors.appBlackColor_1e1e1e,
        justifyContent: "space-between",
        borderRadius: 10,
        marginVertical: 5,
        marginHorizontal: 5,
        paddingHorizontal: 15,
        paddingVertical: 12,
        // width: screenWidth / 4,
        gap: 18,
      },
      purchaseNowButtonStyle: {
        height: 40,
        backgroundColor: AppColors.appViolentColor_6D08C3,
        borderRadius: 10,
        justifyContent: "center",
        paddingHorizontal: 30,
      },
    },
    [DEVICE_SIZES.XS]: {
      container: {
        flex: 1,
        backgroundColor: AppColors.black_121212,
        paddingHorizontal: "3.5%",
        paddingTop: "2.5%",
      },
      needHelpButtonStyle: {
        justifyContent: "flex-end",
        alignItems: "center",
        flexDirection: "row",
        paddingHorizontal: 20,
        marginVertical: 5,
        gap: 8,
      },
      packegeSelectionView: {
        borderRadius: 10,
        borderWidth: 1,
        borderColor: AppColors.appViolentColor_6D08C3,
        flexDirection: "row",
        overflow: "hidden",
      },
      separaterStyle: {
        height: 2,
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        marginVertical: 10,
      },
      tokenButtonStyle: {
        justifyContent: "center",
        alignItems: "center",
        padding: 10,
        paddingHorizontal: 29,
      },
      packageBgView: {
        backgroundColor: AppColors.appBlackColor_1e1e1e,
        justifyContent: "space-between",
        borderRadius: 10,
        marginVertical: 5,
        marginHorizontal: 5,
        paddingHorizontal: 15,
        paddingVertical: 12,
        // width: screenWidth / 4,
        gap: 18,
      },
      purchaseNowButtonStyle: {
        height: 40,
        backgroundColor: AppColors.appViolentColor_6D08C3,
        borderRadius: 10,
        justifyContent: "center",
        paddingHorizontal: 30,
      },
    },
  }
);
